<template>
  <div class="subject-box start-exam">
    <el-row :gutter="30">
      <el-col :span="span1">
        <div class="subject-box-card">
          <div class="subject-exam-title">{{exam.examinationName}}</div>
          <div class="subject-exam-subtitle">（共{{subjectIds.length}}题，合计{{exam.totalScore}}分）</div>
  
          <!-- 免费体验提示 -->
          <div v-show="!hasPaid && currentSubjectIndex > freeSubjectCount" class="free-trial-end">
            <div class="pay-reminder">
              <h3>免费体验已结束</h3>
              <p>您已体验了{{freeSubjectCount}}道免费题目，{{payFlag?'提交':'支付'}}后可继续作答全部{{subjectIds.length}}道题目</p>
              <el-button type="danger" @click="showPayDialog" v-if="!payFlag">立即支付</el-button>
              <el-button type="danger" @click="infoConfirmDialogVisible = true" v-else>提交</el-button>
            </div>
          </div>
          <div v-show="hasPaid||currentSubjectIndex <= freeSubjectCount" class="subject-list">
            <!-- 题目内容 -->
            <choices ref="choices" v-show="this.subject.type === 0" @answer-selected="handleAnswerSelected" />
            <short-answer ref="shortAnswer" v-show="this.subject.type === 1" />
            <judgement ref="judgement" v-show="this.subject.type === 2" />
            <multiple-choices ref="multipleChoices" v-show="this.subject.type === 3" />
            <div v-if="exam.type==2">
              <!-- 查看解析按钮 -->
              <div class="view-analysis-btn">
                <el-button type="primary" @click="handleViewAnalysis" :loading="loadingAnalysis">
                  <i class="el-icon-view"></i> 查看解析
                </el-button>
              </div>
  
              <!-- 解析展示区域 -->
              <div class="subject-analysis" v-if="showAnalysis && analysisResult">
                <div class="analysis-header">
                  <span class="analysis-title">题目解析</span>
                  <el-button type="text" @click="showAnalysis = false">
                    <i class="el-icon-close"></i> 收起
                  </el-button>
                </div>
  
                <div class="answer-result" :class="analysisResult.correct ? 'correct' : 'incorrect'">
                  <i :class="analysisResult.correct ? 'el-icon-success' : 'el-icon-error'"></i>
                  {{ analysisResult.correct ? '回答正确' : '回答错误' }}
                </div>
  
                <div class="answer-section">
                  <p><strong>你的答案：</strong> {{ analysisResult.userAnswer || '未作答' }}</p>
                  <p><strong>正确答案：</strong> {{ analysisResult.correctAnswer }}</p>
                </div>
  
                <div class="analysis-content">
                  <p><strong>解析：</strong></p>
                  <div v-html="analysisResult.analysis"></div>
                </div>
              </div>
  
            </div>
            <div class="subject-buttons" v-if="query.subjectId !== ''">
              <el-button plain @click="last" :loading="loadingLast">上一题</el-button>
              <el-button plain @click="next" :loading="loadingNext">下一题</el-button>
            </div>
          </div>
  
        </div>
      </el-col>
      <el-col :span="span2">
        <div class="tool-bar">
  
          <el-button type="success" icon="el-icon-date" @click="submitExam" v-bind:disabled="disableSubmit">交卷
          </el-button>
  
          <div class="paper-info">
            题目总数: 共{{subjectIds.length}}题
          </div>
  
          <div class="paper-info">
            试卷总分: {{exam.totalScore}}分
          </div>
  
          <div class="paper-info">
            作答时长: {{exam.duration}}分钟
          </div>
  
          <div class="paper-info time-remain">
            剩余时间:
            <div class="time">
              <count-down v-on:start_callback="countDownS_cb(1)" v-on:end_callback="countDownE_cb(1)"
                :current-time="currentTime" :start-time="startTime" :end-time="endTime" :tip-text="'距离考试开始'"
                :tip-text-end="'距离考试结束'" :end-text="'考试结束'" :hourTxt="':'" :minutesTxt="':'" :secondsTxt="''">
              </count-down>
            </div>
          </div>
          <div class="paper-info current-progress">
            当前进度: {{completedCount}}/{{subjectIds.length}}
          </div>
          <div class="answer-card">
            <el-row class="answer-card-content">
              <el-button
                :class="{ 'answered': subjectIds[index].answered , 'free': index < freeSubjectCount,
                                                                                                                                                                                                                                                                                                                                    'paid': index >= freeSubjectCount,
                                                                                                                                                                                                                                                                                                                                    'current': currentSubjectIndex === index + 1}"
                circle v-for="(value, index) in subjectIds" :key="index"
                @click="toSubject(value.subjectId, value.type, index)">
                <span v-if="index >= freeSubjectCount&&!payFlag" class="paid-label"> <span>付费</span>
                  <span>题目</span></span>
                <span v-else-if="index >= freeSubjectCount&&payFlag" class="paid-label"> <span>完善</span>
                  <span>资料</span></span>
                <span v-else class="paid-label">&nbsp;{{index + 1}}&nbsp;
  
                </span>
              </el-button>
            </el-row>
          </div>
          <div class="paper-info" style="margin-top: 16px">
            <p style="font-weight: bold">注意事项：</p>
            <div>
              {{exam.attention}}
            </div>
          </div>
  
  
  
        </div>
      </el-col>
    </el-row>
    <el-dialog title="答题卡" :visible.sync="dialogVisible" width="50%" top="10vh" center>
      <div class="answer-card-title">{{exam.examinationName}}（共{{subjectIds.length}}题，合计{{exam.totalScore}}分）</div>
      <div class="answer-card-split"></div>
      <el-row class="answer-card-content">
        <!--        <el-button circle v-for="(value, index) in subjectIds" :key="index"-->
        <!--                   @click="toSubject(value.subjectId, value.type, index)">&nbsp;{{index + 1}}&nbsp;-->
        <!--        </el-button>-->
  
        <el-button :class="{ 'answered': subjectIds[index].answered }" circle v-for="(value, index) in subjectIds"
          :key="index" @click="toSubject(value.subjectId, value.type, index)">&nbsp;{{index + 1}}&nbsp;</el-button>
  
      </el-row>
    </el-dialog>
  
    <el-dialog :visible.sync="payDialogVisible" title="支付解锁完整题库" width="400px" @close="handlePayDialogClose" center>
      <div class="pay-dialog-content">
        <div class="pay-header">
          <div class="user-count">累计超30000考生使用</div>
          <h3>山西家庭教育学会网络学院题库</h3>
          <p class="features">更新 · 更准 · 更快</p>
        </div>
  
        <div class="price-section">
          <div class="price">￥{{exam.payTyAmount}}</div>
          <!-- <div class="original-price">原价:￥599.00</div> -->
        </div>
  
        <div class="qrcode-section" v-if="!isWeixin">
          <div class="qrcode-placeholder">
            <p>请使用微信扫描二维码支付</p>
            <div class="qrcode-image">
              <!-- <img v-if="qrCodeImageUrl" :src="qrCodeImageUrl" alt="微信支付二维码" style="width: 200px; height: 200px;"> -->
              <canvas v-show="qrCodeImageUrl" ref="qrCanvas"></canvas>
              <div v-show="!qrCodeImageUrl" class="qrcode-demo">
                <i class="el-icon-picture" style="font-size: 80px; color: #ddd;"></i>
                <p>二维码加载中...</p>
              </div>
            </div>
          </div>
        </div>
  
        <div class="pay-notice">
          <p>支付成功后即可解锁全部{{subjectIds.length}}道题目</p>
        </div>
      </div>
  
      <div slot="footer" class="dialog-footer">
        <el-button @click="payDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="initiatePayment" v-if="isWeixin">微信支付</el-button>
        <!-- <el-button type="primary" @click="initiatePayment" v-else>微信支付</el-button> -->
      </div>
    </el-dialog>
    <el-dialog title="信息确认" :visible.sync="infoConfirmDialogVisible" width="500px" class="info-confirm-dialog" center
      :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true">
      <div class="form-description">
        根据服务规范，需登记您的姓名与联系方式，以便提供个性化支持。
      </div>
      <el-form :model="userInfoForm" :rules="userInfoRules" ref="userInfoForm" label-width="80px">
        <el-form-item label="姓名" prop="nickName">
          <el-input v-model="userInfoForm.nickName" placeholder="请输入姓名" maxlength="10" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phonenumber">
          <el-input v-model="userInfoForm.phonenumber" placeholder="请输入手机号"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUserInfo" class="submit-btn" :loading="submitting">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
const { body } = document;
const WIDTH = 1060; // refer to Bootstrap's responsive design
import { isWeixin } from "@/utils/utils";
import { weChatPayment } from '@/utils/wechatPayment.js';
import CountDown from 'vue2-countdown'
import { saveAndNext, selectOrderStatusOrderId, getByExaminationId } from '@/api/exam/answer'
import { getSubjectIds } from '@/api/exam/subject'
import { answerQuestions } from '@/api/exam/examRecord'
import { getCurrentTime } from '@/api/admin/sys'
import { getSubjectAnswer } from '@/api/exam/subject'
import { createPaperOrder } from '@/api/wechat/wxAuth.js'
import { updateUserProfile } from '@/api/admin/user'
import store from '@/store'
import moment from 'moment'
import { messageSuccess, messageFail, messageWarn, isNotEmpty } from '@/utils/util'
import Tinymce from '@/components/Tinymce'
import Choices from '@/components/Subjects/Choices'
import MultipleChoices from '@/components/Subjects/MultipleChoices'
import ShortAnswer from '@/components/Subjects/ShortAnswer'
import Judgement from '@/components/Subjects/Judgement'
import { nextSubjectType } from '@/const/constant'
import QRCode from 'qrcode'
let callBackPayFn = null, clearSettimeoutFn = null;
export default {
  components: {
    CountDown,
    Tinymce,
    Choices,
    MultipleChoices,
    ShortAnswer,
    Judgement
  },
  data() {
    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号'));
      }
      // 手机号正则表达式
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!phoneReg.test(value)) {
        return callback(new Error('请输入正确的手机号格式'));
      }
      callback();
    };
    return {
      isWeixin: false,
      span1: 18,
      span2: 5,
      loadingLast: false,
      loadingNext: false,
      loadingSubmit: false,
      currentTime: 0,
      startTime: 0,
      endTime: 0,
      disableSubmit: true,
      subjectIndex: 1,
      lastSubjectIndex: 1,
      query: {
        examinationId: undefined,
        examRecordId: undefined,
        subjectId: undefined,
        userId: undefined,
        type: 0
      },
      subject: {
        type: 0
      },
      option: '',
      answer: '',
      dialogVisible: false,
      tempAnswer: {
        id: null,
        userId: null,
        examinationId: null,
        courseId: null,
        subjectId: null,
        answer: null,
        type: 0
      },
      subjectIds: [],
      subjectStartTime: undefined,
      completedCount: 0, // 新增：已完成的题目数量
      currentSubjectIndex: 1, // 新增：当前题目位置（取代原subjectIndex）
      freeSubjectCount: 2, // 免费体验题目数量
      hasPaid: false, // 是否已支付
      completedCount: 0, // 已完成题目数量
      payDialogVisible: false, // 支付弹窗显示控制
      qrCodeImageUrl: '', // 二维码图片URL

      showAnalysis: false,      // 控制解析显示状态
      analysisResult: {
        correct: false,        // 是否正确
        userAnswer: '',
        correctAnswer: '',
        analysis: ''
      },     // 存储解析结果
      loadingAnalysis: false,   // 解析加载状态
      sessionId: '', //唯一会话标识
      // 控制信息确认弹窗显示
      infoConfirmDialogVisible: false,
      // 表单提交状态
      submitting: false,
      // 表单数据
      userInfoForm: {
        nickName: '',
        phonenumber: ''
      },
      // 表单验证规则
      userInfoRules: {
        nickName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { max: 10, message: '姓名不能超过10个字', trigger: 'blur' }
        ],
        phonenumber: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ]
      },
      isUserInfoMerged: false, // 是否已合并用户信息
      payFlag: false, // 支付状态

    }
  },

  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo,

    }),
    ...mapGetters([
      'exam', 'examRecord', 'examtype'
    ])
  },
  created() {

    this.isWeixin = isWeixin();

    console.log(this.examtype, 'examtype')
    this.resizeHandler()
    const examInfo = this.$route.params.id
    if (isNotEmpty(examInfo)) {
      let examInfoArr = examInfo.split('-')
      this.query.examinationId = examInfoArr[0]
      this.query.examRecordId = examInfoArr[1]
      this.query.subjectId = isNotEmpty(examInfoArr[2]) ? examInfoArr[2] : this.subject.id
      this.query.type = parseInt(examInfoArr[3])
      this.query.userId = this.userInfo.userId
      this.validateExamTime()
      this.getExamInfo()
    }
  },
  watch: {
    payDialogVisible(newVal) {
      if (!newVal) {
        // 当弹窗关闭时清除定时器
        this.clearTimeOut();

      }
    },
    userInfo: {

      handler(newVal) {

        if (newVal && !this.isUserInfoMerged) {
          const copiedUserInfo = JSON.parse(JSON.stringify(newVal));
          delete copiedUserInfo.nickName;
          delete copiedUserInfo.phonenumber;
          Object.assign(this.userInfoForm, copiedUserInfo);
          this.isUserInfoMerged = true;
        }

      },

      immediate: true,

      deep: true

    }
  },
  beforeMount() {
    window.addEventListener('resize', this.resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler)
    this.clearTimeOut();
  },
  beforeRouteLeave(to, from, next) {
    // 清除所有定时器
    this.clearTimeOut();

    next(); // 必须调用 next()
  },
  methods: {
    ...mapMutations(["SET_TYPE",]),

    countDownS_cb: function (x) {
      messageSuccess(this, '考试开始');
    },
    // 处理子组件传递的答案选择事件
    handleAnswerSelected(userAnswer) {
      // 保存用户答案到父组件的数据中，以便在解析中使用
      // this.tempAnswer.answer = userAnswer;
      // 调用解析方法
      // this.handleViewAnalysis();
    },
    // 原有的解析方法（稍作调整）
    async handleViewAnalysis() {
      const answerId = isNotEmpty(this.tempAnswer) ? this.tempAnswer.id : ''
      const answer = await this.getAnswer(answerId)
      console.log('answer', answer);
      this.tempAnswer.answer = answer.answer || ''
      // // 如果没有选择答案，则不显示解析
      // if (!this.tempAnswer.answer) {
      //   this.showAnalysis = false;
      //   return;
      // }
      this.loadingAnalysis = true;
      try {
        // 使用用户答案获取解析
        const response = await this.getAnalysis(this.tempAnswer.answer);
        // 设置解析结果
        this.analysisResult.userAnswer = this.tempAnswer.answer;
        this.analysisResult.correct = response.data.result;
        this.analysisResult.correctAnswer = response.data.answer;
        this.analysisResult.analysis = response.data.analysis;
        // 显示解析框
        this.showAnalysis = true;
      } catch (error) {
        console.error('获取解析失败', error);
        this.$message.error('获取解析失败');
      } finally {
        this.loadingAnalysis = false;
      }
    },
    // 
    async getAnalysis(userAnswer) {
      // 假设您有一个API函数 checkAnswer，接受 subjectId 和 userAnswer
      const response = await answerQuestions({
        subjectId: this.query.subjectId,
        answer: userAnswer,

      });
      return response;
    },

    validateExamTime() {
      getCurrentTime().then(response => {
        const currentTime = moment(response.msg);

        if (this.exam.type == 0) {
          if (currentTime.isAfter(this.exam.endTime)) {
            messageWarn(this, '考试已结束');
            return;
          } else if (currentTime.isBefore(this.exam.startTime)) {
            messageWarn(this, '考试未开始');
            return;
          }
        }

        this.startExam()
        const current = currentTime.valueOf()
        this.currentTime = current
        this.startTime = current
        this.subjectStartTime = current;
        this.endTime = moment(this.examRecord.startTime).add(this.exam.duration, 'minutes').valueOf()
        this.disableSubmit = false


      }).catch(() => {
        messageFail(this, '开始考试失败1！')
      })
    },
    checkUserInfoSubmitted() {



      return new Promise((resolve) => {



        store.dispatch('GetUserInfo').then(res => {
          console.log('重新获取用户信息成功.')
          if (res.user.nickName && res.user.phonenumber) {
            resolve(true);
          } else {
            resolve(false);
          }
        }).catch((err) => {
          console.error(err)
        })



      });

    },
    getExamInfo() {
      getByExaminationId(this.query.examinationId).then(response => {
        console.log(response, 'response.data111')
        if (!response || !response.data) {
          // 处理response或response.data为空的情况，例如设置为默认状态或提示用户
          if (this.exam.payTyNum) {
            this.freeSubjectCount = this.exam.payTyNum
          } else {
            this.freeSubjectCount = this.exam.subjectCount
          }
          this.hasPaid = false
          return;
        }
        const { status } = response.data;


        if (status == 0) {
          console.log(this.exam, 'exam')
          if (this.exam.payTyNum) {
            this.freeSubjectCount = this.exam.payTyNum
          } else {
            this.freeSubjectCount = this.exam.subjectCount
          }
          this.hasPaid = false
          return;
        } else if (status == 1) {
          this.payFlag = true;
          // this.freeSubjectCount = this.exam.subjectCount;
          // this.hasPaid = true


          // 支付成功，检查用户信息是否提交
          this.checkUserInfoSubmitted().then(submitted => {
            if (submitted) {
              this.freeSubjectCount = this.exam.subjectCount;
              this.hasPaid = true;
            } else {
              this.freeSubjectCount = this.exam.payTyNum
              this.hasPaid = false;
              this.infoConfirmDialogVisible = true; // 弹出信息确认框
            }
          });
          return;
        }


      })
    },
    // 提交用户信息
    submitUserInfo() {
      this.$refs.userInfoForm.validate((valid) => {
        if (valid) {
          this.submitting = true;

          updateUserProfile(this.userInfoForm).then(response => {
            // notifySuccess(this, '修改成功')
            this.$message.success('修改成功！');
            // 重新拉取用户信息
            store.dispatch('GetUserInfo').then(res => {
              console.log('重新获取用户信息成功.')
              this.submitting = false;

              // 提交成功后，设置已提交状态
              // localStorage.setItem('userInfoSubmitted', 'true');

              this.$message.success('信息提交成功');

              this.infoConfirmDialogVisible = false;
              this.freeSubjectCount = this.exam.subjectCount;
              this.hasPaid = true;
            }).catch((err) => {
              console.error(err)
            })
          }).catch((err) => {
            console.log(err, 555555555555555555)
            this.submitting = false;
            this.$message.error('修改失败，请重试');
            // notifyFail(this, '修改失败')
          })

        } else {
          return false;
        }
      });
    },
    startExam() {
      // 获取题目ID列表
      getSubjectIds(this.query.examinationId).then(subjectResponse => {
        const subjectData = subjectResponse.data
        this.subject.type = this.query.type = subjectData[0].type
        console.log(this.subject.type, 'type')
        if (subjectData.length > 0) {
          for (let i = 0; i < subjectData.length; i++) {
            const { subjectId, type } = subjectData[i]
            this.subjectIds.push({ subjectId, type, index: i + 1, answered: false })
          }
          this.updateSubjectIndex();

          if (this.query.subjectId < 1) {
            let { subjectId, index } = this.subjectIds[0]
            this.query.subjectId = subjectId;
          }

          // 获取当前题目信息
          getSubjectAnswer({
            examRecordId: this.query.examRecordId,
            subjectId: this.query.subjectId,
            type: this.query.type,
            nextType: -1
          }).then(response => {
            if (isNotEmpty(response.data)) {
              console.log(response.data, 'response.data')
              const { answer } = response.data
              this.tempAnswer = answer
              this.setSubjectInfo(response.data)
              // 初始化时统计已完成的题目
              if (answer && answer.answer) {
                const idx = this.subjectIds.findIndex(item => item.subjectId === this.query.subjectId)
                if (idx !== -1 && !this.subjectIds[idx].answered) {
                  this.subjectIds[idx].answered = true
                  this.completedCount += 1
                }
              }
            }
          }).catch(() => {
            // messageFail(this, '获取题目失败！')
          })
        }
      }).catch(() => {
        // messageFail(this, '开始考试失败2！')
      })
    },
    countDownE_cb: function (x) {
      messageWarn(this, '考试结束')
      this.disableSubmit = true;
      //继续考试直接提交
      if (this.examtype === 0) {
        store.dispatch('SubmitExam', { examinationId: this.query.examinationId, examRecordId: this.query.examRecordId, userId: this.userInfo.userId }).then(() => {
          messageSuccess(this, '提交成功')


          this.$router.push({ name: 'exam-record' })


        }).catch(() => {
          this.disableSubmit = false
          // messageFail(this, '提交题目失败')
        })
      } else {
        this.doSubmitExam(this.tempAnswer, this.query.examinationId, this.query.examRecordId, this.userInfo, true);
      }


    },
    last() {
      for (let i = 0; i < this.subjectIds.length; i++) {
        if (this.subjectIds[i].subjectId == this.query.subjectId) {
          if (i == 0) {
            messageSuccess(this, '已经是第一题了')
            break
          }
          if (!this.hasPaid && this.currentSubjectIndex - 1 >= this.freeSubjectCount) {
            if (this.payFlag) {
              this.infoConfirmDialogVisible = true
            } else {
              this.showPayDialog();
            }

            return;

          }
          this.currentSubjectIndex -= 1;
          let { subjectId, type, index } = this.subjectIds[--i]
          this.subjectIndex = index
          // 重置解析状态
          this.showAnalysis = false;
          this.analysisResult = {
            correct: false,
            userAnswer: '',
            correctAnswer: '',
            analysis: ''
          };
          this.saveCurrentSubjectAndGetNextSubject(nextSubjectType.last, subjectId, type)
          break
        }
      }
    },
    next() {
      for (let i = 0; i < this.subjectIds.length; i++) {
        if (this.subjectIds[i].subjectId == this.query.subjectId) {
          if (i == this.subjectIds.length - 1) {

            this.saveCurrentAnswer().then(() => {
              messageSuccess(this, '已经是最后一题了,请提交试卷');
            });
            break
          }



          this.currentSubjectIndex += 1;
          // 只传递必要参数
          let { subjectId, type, index } = this.subjectIds[i + 1]
          this.subjectIndex = index
          // 重置解析状态
          this.showAnalysis = false;
          this.analysisResult = {
            correct: false,
            userAnswer: '',
            correctAnswer: '',
            analysis: ''
          };
          this.saveCurrentSubjectAndGetNextSubject(nextSubjectType.next, subjectId, type);
          if (!this.hasPaid && this.currentSubjectIndex > this.freeSubjectCount) {
            if (this.payFlag) {
              this.infoConfirmDialogVisible = true
            } else {
              this.showPayDialog();
            }
            return;
          }
          window.scroll(0, 0);
          break
        }
      }
    },
    // 显示支付弹窗
    showPayDialog() {
      if (!this.isWeixin) {
        this.initiatePayment();
      }
      this.payDialogVisible = true;
    },

    // 模拟支付成功
    simulatePayment() {
      this.hasPaid = true;
      this.payDialogVisible = false;
      this.$message.success('支付成功，已解锁全部题目！');
    },
    executeWechatJSAPIPayment(response) {
      // 执行微信JSAPI支付
      const paymentParams = {
        appId: response.data.appId,
        nonceStr: response.data.nonceStr,
        timestamp: response.data.timeStamp,
        paySign: response.data.paySign,
        packages: response.data.package,
        signType: response.data.signType || 'RSA'
      };

      // 调用支付
      weChatPayment(
        paymentParams,
        // 成功回调
        () => {
          this.payDialogVisible = false;
          this.getExamInfo();
          this.$message.success('支付成功！已解锁全部题目');

        },
        // 失败回调
        (error) => {
          this.$message.error('支付失败，请重试');
          console.error('支付失败详情:', error);
        },
        // 取消回调
        () => {
          this.$message.info('您已取消支付');
        }
      );
    },
    executeNativePayment(response) {
      // 执行非微信环境支付
      // 从支付数据中获取二维码链接
      const qrCodeUrl = response.data.codeUrl;

      if (qrCodeUrl) {
        // 显示二维码
        this.generateQrCode(qrCodeUrl, response.data.orderTradeNo);

        // 开始轮询支付结果
        // this.pollPaymentStatus(paymentData.out_trade_no);
      } else {
        this.$message.error('无法生成支付二维码');
      }
    },
    generateQrCode(codeUrl, orderTradeNo) {
      console.log('codeUrl', codeUrl)
      this.clearTimeOut()
      clearSettimeoutFn = setTimeout(() => {
        QRCode.toCanvas(this.$refs.qrCanvas, codeUrl, { width: 150, height: 150 }, (err) => {
          if (err) {
            console.error('生成二维码失败：', err);
          } else {
            console.log('生成二维码成功');
            this.qrCodeImageUrl = true
            callBackPayFn = setInterval(async () => {
              const { data } = await selectOrderStatusOrderId(orderTradeNo)
              console.log(1111, data)
              // 订单状态 0 待支付 1支付成功 2 生成失败
              if (data.status === 0) {
                console.log('订单状态：待支付')

              } else if (data.status === 1) {
                this.$message.success('支付成功！')
                this.payDialogVisible = false;
                this.clearTimeOut()
                this.getExamInfo()
              } else if (data.status === 2) {
                // tishi：生成失败
                this.$message.error('支付失败！')
                // 更新二维码
                this.initiatePayment()
                this.clearTimeOut()
              }
            }, 3000);
          }
        });
      }, 500)
    },
    clearTimeOut() {
      if (callBackPayFn) {
        clearInterval(callBackPayFn)
      }
      callBackPayFn = null
      if (clearSettimeoutFn) {
        clearTimeout(clearSettimeoutFn)
      }
      clearSettimeoutFn = null
    },
    initiatePayment() {
      // 获取支付参数
      const params = {
        examinationId: this.query.examinationId,
        source: this.isWeixin ? 1 : 2
      }
      createPaperOrder(params).then(response => {

        if (this.isWeixin) {
          // 微信环境使用JSAPI支付
          this.executeWechatJSAPIPayment(response);
        } else {
          // 非微信环境使用Native支付
          this.executeNativePayment(response);
        }

      }).catch(error => {
        this.$message.error('获取支付参数失败');
        console.error('获取支付参数错误:', error);
      });
    },
    // 新增保存当前答案的方法
    saveCurrentAnswer() {
      const answerId = isNotEmpty(this.tempAnswer) ? this.tempAnswer.id : '';
      const answer = this.getAnswer(answerId);

      return new Promise((resolve, reject) => {
        this.startLoading(nextSubjectType.next);
        saveAndNext(answer, nextSubjectType.current, this.query.subjectId, this.query.type)
          .then(response => {
            if (response.data !== null) {
              this.markAnswered(this.answer, this.lastSubjectIndex - 1);
              this.endLoading(nextSubjectType.next);
              resolve();
            }
          })
          .catch(error => {
            messageFail(this, '保存失败');
            this.endLoading(nextSubjectType.next);
            reject(error);
          });
      });
    },
    // 保存当前题目，同时根据序号加载下一题
    saveCurrentSubjectAndGetNextSubject(nextType, nextSubjectId, subjectType) {
      console.log('saveCurrentSubjectAndGetNextSubject', nextType, nextSubjectId, subjectType)
      const answerId = isNotEmpty(this.tempAnswer) ? this.tempAnswer.id : ''
      console.log('answerId', this.tempAnswer.id, answerId)
      const answer = this.getAnswer(answerId)
      console.log(answer, 'answer')
      const _this = this
      this.startLoading(nextType)
      saveAndNext(answer, nextType, nextSubjectId, subjectType).then(response => {
        if (response.data !== null) {
          console.log(_this.answer, this.lastSubjectIndex - 1, 555555555555555555)
          this.markAnswered(_this.answer, this.lastSubjectIndex - 1)
          this.lastSubjectIndex = this.subjectIndex
          const subject = response.data
          const { id, type, answer } = subject
          this.query.subjectId = id
          this.query.type = type

          this.subject = subject; // 更新题目对象（含type）
          this.tempAnswer = answer
          this.tempAnswer.index = this.subjectIndex
          this.setSubjectInfo(subject)
          store.dispatch('SetSubjectInfo', subject).then(() => { })
          this.updateSubjectIndex()
        }
        // 更新时间
        getCurrentTime().then(response => {
          this.subjectStartTime = moment(response.msg)
        })
        this.endLoading(nextType)
      }).catch((error) => {
        // console.log(error)
        messageFail(this, '获取题目失败')
        this.endLoading(nextType)
      })
    },
    markAnswered(answer, index) {
      if (answer && answer !== null) {
        if (!this.subjectIds[index].answered) {
          console.log('markAnswered', this.subjectIds, index)
          this.subjectIds[index].answered = true;
          this.completedCount += 1; // 关键：只在首次完成时增加计数
        }
      }
    },
    // 答题卡
    answerCard() {
      this.dialogVisible = true
    },
    // 跳转题目
    toSubject(subjectId, subjectType, index) {
      if (!this.hasPaid && index >= this.freeSubjectCount) {
        if (this.payFlag) {
          this.infoConfirmDialogVisible = true
        } else {
          this.showPayDialog();
        }

        return;
      }
      this.currentSubjectIndex = index + 1 // 更新当前题目位置
      this.subjectIndex = index + 1
      // 重置解析状态
      this.showAnalysis = false;
      this.analysisResult = {
        correct: false,
        userAnswer: '',
        correctAnswer: '',
        analysis: ''
      };
      // 保存当前题目，同时加载下一题
      this.saveCurrentSubjectAndGetNextSubject(nextSubjectType.current, subjectId, subjectType)
      this.dialogVisible = false
    },
    // 处理支付弹窗关闭
    handlePayDialogClose() {
      this.clearTimeOut(); // 关闭弹窗时清除定时器

    },
    // 提交
    submitExam() {
      this.$confirm('确定要提交吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.disableSubmit = true
        this.doSubmitExam(this.tempAnswer, this.query.examinationId, this.query.examRecordId, this.userInfo, true)
      }).catch(() => {
      })
    },
    doSubmitExam(answer, examinationId, examRecordId, userInfo, toExamRecord) {
      const answerId = isNotEmpty(answer) ? answer.id : ''
      saveAndNext(this.getAnswer(answerId), 0).then(response => {
        // 提交到后台
        store.dispatch('SubmitExam', { examinationId, examRecordId, userId: userInfo.userId }).then(() => {
          messageSuccess(this, '提交成功')
          if (toExamRecord) {
            this.$router.push({ name: 'exam-record' })
          }
        }).catch(() => {
          this.disableSubmit = false
          // messageFail(this, '提交题目失败')
        })
      }).catch(() => {
        this.disableSubmit = false
        // messageFail(this, '提交题目失败')
      })
    },
    // 选中选项
    toggleOption(answer) {
      this.answer = answer
    },
    // 根据题目类型返回填写的答案
    getAnswer(answerId) {
      const ref = this.getSubjectRef()
      if (isNotEmpty(ref)) {
        const answer = ref.getAnswer()
        this.answer = answer
        return {
          id: answerId,
          userId: this.userInfo.id,
          examinationId: this.query.examinationId,
          examRecordId: this.query.examRecordId,
          subjectId: this.query.subjectId,
          answer: answer,
          type: this.query.type,
          startTime: this.subjectStartTime.valueOf()
        }
      }
      return {}
    },
    // 获取题目索引
    getSubjectIndex(targetId) {
      for (let subject of this.subjectIds) {
        let { subjectId, index } = subject
        if (subjectId === targetId) {
          return index
        }
      }
      return 1
    },
    // 更新题目索引
    updateSubjectIndex() {
      this.subjectIndex = this.getSubjectIndex(this.query.subjectId)


    },
    startLoading(nextType) {
      if (nextType === nextSubjectType.next) {
        this.loadingNext = true
      } else if (nextType === nextSubjectType.last) {
        this.loadingLast = true
      } else {
        this.loadingNext = true
      }
    },
    endLoading(nextType) {
      if (nextType === nextSubjectType.next) {
        this.loadingNext = false
      } else if (nextType === nextSubjectType.last) {
        this.loadingLast = false
      } else {
        this.loadingNext = false
      }
    },
    getSubjectRef() {
      let ref
      switch (this.query.type) {
        case 0:
          ref = this.$refs.choices
          break
        case 1:
          ref = this.$refs.shortAnswer
          break
        case 2:
          ref = this.$refs.judgement
          break
        case 3:
          ref = this.$refs.multipleChoices
          break
      }
      return ref
    },
    setSubjectInfo(subject) {
      const ref = this.getSubjectRef()
      console.log(ref, 'ddddd')
      if (isNotEmpty(ref)) {
        try {
          console.log(ref, 'ddddd')
          ref.setSubjectInfo(subject, this.subjectIds.length, this.subjectIndex)
        } catch (error) {
          console.error(error)
        }
      }
    },
    isMobile() {
      const rect = body.getBoundingClientRect();
      var isMobile = rect.width - 1 < WIDTH;

      return isMobile;
    },
    resizeHandler() {
      if (document.hidden) {
        return;
      }

      const isMobile = this.isMobile();

      if (isMobile) {
        this.span1 = 23;
        this.span2 = 23;
      } else {
        this.tableSpan = 18;
        this.tableOffset = 5;
      }


    },



  }
}
</script>

<style>
.start-exam .subject-content {
  width: 100%;
  text-align: left;
}

.start-exam .subject-options>li .toggle+label {
  text-align: left;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss" scoped>
.subject-exam-title {
  width: 100%;
  font-size: 1.3rem;
  text-align: center;
  font-weight: bold;
}

.subject-exam-subtitle {
  width: 100%;
  font-size: 1.1rem;
  text-align: center;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
}

.subject-box {
  margin-top: 50px;
  margin-left: 20px;
}

.subject-box-card {
  margin-bottom: 30px;
  min-height: 400px;
}

.subject-buttons {
  text-align: center;
}

.tool-bar {
  margin-left: 20px;
}

.time-remain .time {
  display: inline-block;
  font-size: 18px;
  line-height: 22px;
  color: #FF0000;
  font-weight: 400;
}

/* 答题卡 */
.answer-card-title {
  font-size: 13px;
  color: #3A3E51;
  line-height: 17px;
  padding: 10px 0;
}

.answer-card-split {
  width: 100%;
  border-bottom: 1px solid #E6E6E6;
}

.answer-card-content {
  padding-bottom: 10px;
  font-size: 0;
  margin-right: -15px;
  position: relative;

  >button {
    width: 42px;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
    margin-top: 5px;
    margin-left: 0px !important;
    margin-right: 10px !important;
  }
}

.paper-info {
  margin-top: 10px;
}

.answered {
  background-color: greenyellow;
}

.answer-card-content .free {
  background-color: #ffffff;
  color: #606266;
  border: 1px solid #dcdfe6;
}

.answer-card-content .paid {
  background-color: #ff4d4f;
  color: #ffffff;
}

.answer-card-content .paid-label {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 1em;
  height: 38px;
  font-size: 12px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // position: absolute;
  // bottom: -20px;
  // left: 50%;
  // transform: translateX(-50%);
  // font-size: 12px;
  // color: #ff4d4f;
  // white-space: nowrap;
}

.answer-card-content .paid-label span {

  display: block;
  line-height: 1em;
  height: 1em;
  overflow: hidden;
    margin: 0;
  padding: 0;
}

.answer-card-content .el-button {
  position: relative;
  min-width: 42px;
  min-height: 42px;
  padding: 0;
}

.answer-card-content .current {
  border: 2px solid #409EFF;
}

.answer-card-content .answered {
  background-color: #67c23a;
  color: #ffffff;
}

.pay-dialog-content {
  text-align: center;
}

.pay-header {
  margin-bottom: 20px;
}

.user-count {
  background-color: #ff7700;
  color: white;
  display: inline-block;
  padding: 5px 15px;
  border-radius: 15px;
  font-size: 12px;
  margin-bottom: 10px;
}

.pay-header h3 {
  margin: 10px 0 5px;
  color: #303133;
  font-size: 20px;
}

.features {
  color: #909399;
  font-size: 14px;
  margin: 0;
}

.price-section {
  margin: 20px 0;
}

.price {
  font-size: 28px;
  color: #ff4d4f;
  font-weight: bold;
}

.original-price {
  font-size: 14px;
  color: #909399;
  text-decoration: line-through;
}

.qrcode-section {
  margin: 20px 0;
}

.qrcode-placeholder p {
  margin-bottom: 10px;
  color: #606266;
}

.qrcode-image {
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  padding: 15px;
  display: inline-block;
}

.qrcode-demo {
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f5f7fa;
  color: #909399;
}

.pay-notice {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #e6e6e6;
}

.pay-notice p {
  color: #606266;
  font-size: 14px;
  margin: 0;
}

.free-trial-end {
  text-align: center;
  padding: 40px 20px;
}

 .pay-reminder {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.pay-reminder h3 {
  color: #ff4d4f;
  margin-bottom: 15px;
}

.pay-reminder p {
  color: #606266;
  margin-bottom: 25px;
  font-size: 16px;
}

/* 新增查看解析按钮样式 */
.view-analysis-btn {
  margin: 25px 0;
  text-align: left;
}

/* 新增解析内容样式 */
.subject-analysis {
  margin: 30px;

  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #409EFF;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
}

.analysis-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eaeaea;
}

.analysis-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.answer-result {
  padding: 10px 15px;
  border-radius: 4px;
  font-weight: 500;
  margin-bottom: 15px;
}

.answer-result.correct {
  background-color: rgba(103, 194, 58, 0.1);
  color: #67C23A;
}

.answer-result.incorrect {
  background-color: rgba(245, 108, 108, 0.1);
  color: #F56C6C;
}

.answer-result i {
  margin-right: 8px;
  font-size: 18px;
}

.answer-section {
  margin-bottom: 15px;
  padding: 15px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.answer-section p {
  margin: 8px 0;
  font-size: 15px;
}

.analysis-content {
  padding: 15px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.analysis-content p {
  margin-bottom: 10px;
}

.info-confirm-dialog .el-dialog__header {
  background-color: #f5f7fa;
  padding: 15px 20px;
  border-bottom: 1px solid #e6ebf5;
}

.info-confirm-dialog .el-dialog__body {
  padding: 25px 30px;
}

.info-confirm-dialog .form-description {
  text-align: center;
  margin-bottom: 25px;
  color: #606266;
  line-height: 1.5;
}

.info-confirm-dialog .el-form-item {
  margin-bottom: 22px;
}

.info-confirm-dialog .el-dialog__footer {
  padding: 15px 20px;
  border-top: 1px solid #e6ebf5;
  text-align: center;
}

.info-confirm-dialog .submit-btn {
  width: 120px;
}
</style>
